import React from 'react';
import { string, bool } from 'prop-types';
import { Tooltip } from 'ps-design';

import './SurveyJobTitle.scss';

export default class SurveyJobTitle extends React.Component {
  static propTypes = {
    description: string,
    title: string,
    showJobDescription: bool
  };

  render() {
    const { description, title, showJobDescription } = this.props;
    const hasSurveyJobDescription = description && description.length > 0;

    if (hasSurveyJobDescription && !showJobDescription) {
      return (
        <div className="data-cell__survey-job-title">
          <Tooltip display="underline" hoverText={description} id={title} position="bottom" tooltipText={title} />
        </div>
      );
    }

    return <div className="data-cell__survey-job-title">{title}</div>;
  }
}
